import React, { Component, Fragment } from "react";
import { BrowserRouter as Router, Route, Switch, withRouter } from "react-router-dom";

import lscache from "lscache";

import { ToastContainer, Slide } from "react-toastify";

import LoginHQ from "./pages/Login/hq";
import LoginBranch from "./pages/Login/branch";
import Nav from "./pages/Nav_new"; // <Nav logoutHandeler={this.logoutHandeler} type={type} userId={userId} />
import InternalRoute from "@app/pages/Internal/index";

import * as util from "@app/lib/utility";

export default class main extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLogin: localStorage.getItem("is_login") ? localStorage.getItem("is_login") : false,
            role: localStorage.getItem("login_user_role") ? localStorage.getItem("login_user_role") : "",
        };
    }

    loginHandeler = (isLogin) => {
        this.setState({
            isLogin: isLogin,
        });
    };

    logoutHandeler = (isLogin) => {
        const isLoginFromHq = localStorage.getItem("is_login_from_hq");
        if(isLoginFromHq == "yes") {
            window.document.location.href = "/hq/login";
        } else {
            window.document.location.href = "/";
        }
        localStorage.removeItem("is_login");
        localStorage.removeItem("is_login_from_hq");
        localStorage.removeItem("login_user_name");
        localStorage.removeItem("login_user_id");
        localStorage.removeItem("login_user_index");
        localStorage.removeItem("login_user_role");
        localStorage.removeItem("login_user_type");
        localStorage.removeItem("login_branch_id");
        localStorage.removeItem("login_branch_name");
        localStorage.removeItem("auth_token");
        lscache.flush();
    };

    render() {
        const isInternalPage = util.isInternalPage();
        if(isInternalPage) {
            return <InternalRoute />;
        } else {
            const { isLogin } = this.state;
            const userId = localStorage.getItem("login_user_id");
            const type = localStorage.getItem("login_user_type");
            const urlBase = process.env.REACT_APP_BASE_URL;
    
            if (isLogin === true || isLogin === "true") {
                return (
                    <div className="dashboard-main-wrapper">
                        <Nav logoutHandeler={this.logoutHandeler} type={type} userId={userId} />
                        <ToastContainer autoClose={2000} hideProgressBar={true} transition={Slide} />
                    </div>
                );
            } else {
                return (
                    <Fragment>
                        <Router exact path={urlBase} basename={urlBase}>
                            <Switch>
                                <Route path="/hq/login" component={LoginHQ} />
                                <Route path="/*" component={LoginBranch} />
                            </Switch>
                        </Router>
                    </Fragment>
                );
            }
        }
    }
}
